import React, { useState } from "react";
import Select from "react-select";
import PopupWrapper from "../../../components/PopupWrapper";
import ErrorBoundary from "../../../components/ErrorBoundary";
import { PaymentActivityTable } from "../Pages/LoanDetailsBorrower/LDBDetailTable";
import useBorrowerDashboardTwo from "../BorrowerDashboardTwo/apis/useBorrowerDashboardTwo";
import { useSelector } from "react-redux";

const PaymentActivityModal = ({ show, setShow, showSelect = false }) => {
  const [account, setAccount] = useState(null);
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  const { activeAccountList, accountsLength } = useBorrowerDashboardTwo();

  function handleAccountChange(e) {
    setAccount(e);
  }

  return (
    <div>
      <PopupWrapper
        Component={
          <ErrorBoundary>
            {showSelect ? (
              <div>
                {accountsLength ? (
                  <>
                    <Select
                      options={activeAccountList}
                      value={account ? account : null}
                      onChange={handleAccountChange}
                      classNamePrefix="select"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          primary: "#ef8860",
                        },
                      })}
                    />
                    <PaymentActivityTable
                      modal={true}
                      viewAllModal={false}
                      accountIdFromSelect={account?.value}
                      title="Payment History"
                    />
                  </>
                ) : (
                  <p className="fs-5">No active loans</p>
                )}
              </div>
            ) : null}
          </ErrorBoundary>
        }
        title="Payment History"
        toShow={show}
        closeEventHandler={() => {
          setShow(false);
          setAccount(null);
        }}
      />
    </div>
  );
};

export default PaymentActivityModal;
